export const sidebarItems = [
    { key: 'home', titleKey: 'Home', url: '/home', icon: "Home", section: 'MAIN' },
    { key: 'teams', titleKey: 'Teams', url: '/teams', icon: "Teams", section: 'MAIN' },
    { key: 'players', titleKey: 'Players', url: '/players', icon: "Player", section: 'MAIN' },
    { key: 'matchHistory', titleKey: 'Match History', url: '/matchhistory', icon: "Officials_History", section: 'MAIN' },
    { key: 'roundFinder', titleKey: 'Round Finder', url: '/roundFinder', icon: "Officials_History", section: 'MAIN' },

];
